import { render, staticRenderFns } from "./CustomDomainMgmt.vue?vue&type=template&id=31dd722e&scoped=true"
import script from "./CustomDomainMgmt.vue?vue&type=script&lang=js"
export * from "./CustomDomainMgmt.vue?vue&type=script&lang=js"
import style0 from "./CustomDomainMgmt.vue?vue&type=style&index=0&id=31dd722e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd722e",
  null
  
)

export default component.exports